import React from 'react'
import { Link, useParams } from 'react-router-dom'
import { Space } from 'antd'

import { ScreenSpin } from 'admin/lib/ScreenSpin'
import { Queries } from 'admin/lib/Api'
import { Layout } from 'admin/lib/Layouts'
import { Breadcrumb, BreadcrumbArrayItem } from 'admin/lib/Breadcrumbs'
import * as ROUTES from 'admin/routes'
import { UserEditForm } from './UserEditForm'
import { ShortcutsModalButton } from 'admin/lib/ShortcutsModalButton'
import { ResetUserPasswordButton } from './ResetUserPasswordButton'

export function UserEdit() {
  const { userId } = useParams()

  const isNew = userId === 'new'
  const user = Queries.useUser(isNew ? null : userId)
  const ssoIdps = Queries.useSSOIDPs()
  const userAccountMappings = Queries.useUserAccountMappings(
    isNew ? null : userId
  )

  return (
    <Layout
      header={
        <>
          <Breadcrumb
            items={[
              {
                title: (
                  <BreadcrumbArrayItem>
                    <Link to={ROUTES.USERS.LIST}>Users</Link>
                  </BreadcrumbArrayItem>
                )
              },
              { title: <BreadcrumbArrayItem>{userId}</BreadcrumbArrayItem> }
            ]}
          />

          <Space>
            {!isNew && <ResetUserPasswordButton userId={userId} />}
            <ShortcutsModalButton />
          </Space>
        </>
      }
    >
      {((!user.isFetched && !userAccountMappings.isFetched) ||
        !ssoIdps.isFetched) && <ScreenSpin />}

      {user.isError && <div>{String(user.error)}</div>}
      {userAccountMappings.isError && (
        <div>{String(userAccountMappings.error)}</div>
      )}

      {user.isFetched && userAccountMappings.isFetched && ssoIdps.isFetched && (
        <UserEditForm
          user={user.data}
          userAccountMappings={userAccountMappings.data}
          ssoIdps={ssoIdps.data}
          isNew={isNew}
        />
      )}
    </Layout>
  )
}
